import React from "react";
import { motion } from "framer-motion";

// Simplified UFO mark for the navbar
export const NavbarLogo = () => (
  <svg width="40" height="28" viewBox="0 0 120 84" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <ellipse cx="60" cy="64" rx="40" ry="9" fill="rgba(124,58,237,0.28)" />
    <path d="M18 52 C36 34, 84 34, 102 52 C84 64, 36 64, 18 52 Z" fill="#C7D2FE" />
    <path d="M28 52 C42 42, 78 42, 92 52 C78 60, 42 60, 28 52 Z" fill="rgba(124,58,237,0.22)" />
    <path d="M40 48 C40 28, 80 28, 80 48 Z" fill="rgba(34,211,238,0.24)" stroke="rgba(34,211,238,0.6)" strokeWidth="2" />
    <circle cx="52" cy="40" r="7" fill="#7CF7C2" />
    <circle cx="68" cy="40" r="7" fill="#6EE7FF" />
    <circle cx="50" cy="40" r="1.6" fill="#0B1026" />
    <circle cx="54" cy="40" r="1.6" fill="#0B1026" />
    <circle cx="66" cy="40" r="1.6" fill="#0B1026" />
    <circle cx="70" cy="40" r="1.6" fill="#0B1026" />
    <path d="M44 46 C37 42, 36 34, 42 31" stroke="#7CF7C2" strokeWidth="3" strokeLinecap="round" />
    <path d="M76 46 C83 42, 85 34, 79 31" stroke="#6EE7FF" strokeWidth="3" strokeLinecap="round" />
    <circle cx="40" cy="56" r="2.4" fill="#22D3EE" />
    <circle cx="60" cy="58" r="2.4" fill="#F7C948" />
    <circle cx="80" cy="56" r="2.4" fill="#22D3EE" />
  </svg>
);

// Full hero mark with orb + star + gentle float
export const HeroMark = ({ className = "" }) => {
  const floaty = { animate: { y: [0, -10, 0] }, transition: { duration: 6, repeat: Infinity, ease: "easeInOut" } };
  return (
    <motion.svg {...floaty} className={className} width="340" height="220" viewBox="0 0 340 220" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Shareride UFO with two waving aliens">
      <defs>
        <radialGradient id="orbGrad" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(272 44) rotate(45) scale(46)">
          <stop stopColor="#FFF7D6" />
          <stop offset="0.35" stopColor="#F7C948" />
          <stop offset="0.7" stopColor="#D9A441" />
          <stop offset="1" stopColor="rgba(217,164,65,0)" />
        </radialGradient>
        <radialGradient id="domeGrad" cx="0.5" cy="0" r="1">
          <stop offset="0" stopColor="rgba(34,211,238,0.45)" />
          <stop offset="1" stopColor="rgba(34,211,238,0.12)" />
        </radialGradient>
      </defs>
      {/* Orb + star */}
      <circle cx="272" cy="44" r="30" fill="url(#orbGrad)" />
      <path d="M272 6 L279 30 L303 30 L283 44 L291 68 L272 53 L253 68 L261 44 L241 30 L265 30 Z" fill="#FFF7D6" opacity="0.92" />
      {/* small twinkles */}
      <circle cx="60" cy="36" r="2" fill="#FFF7D6" opacity="0.8" />
      <circle cx="110" cy="20" r="1.6" fill="#6EE7FF" opacity="0.8" />
      <circle cx="40" cy="120" r="1.6" fill="#FFF7D6" opacity="0.7" />
      {/* Saucer shadow */}
      <ellipse cx="160" cy="168" rx="104" ry="20" fill="rgba(124,58,237,0.22)" />
      {/* Saucer body */}
      <path d="M70 142 C96 108, 224 108, 250 142 C224 164, 96 164, 70 142 Z" fill="#C7D2FE" />
      <path d="M88 142 C110 120, 210 120, 232 142 C210 156, 110 156, 88 142 Z" fill="rgba(124,58,237,0.2)" />
      {/* Dome */}
      <path d="M116 136 C116 96, 204 96, 204 136 Z" fill="url(#domeGrad)" stroke="rgba(34,211,238,0.6)" strokeWidth="2.5" />
      {/* Aliens */}
      <circle cx="144" cy="120" r="15" fill="#7CF7C2" />
      <circle cx="176" cy="120" r="15" fill="#6EE7FF" />
      <circle cx="139" cy="119" r="3" fill="#0B1026" />
      <circle cx="149" cy="119" r="3" fill="#0B1026" />
      <circle cx="171" cy="119" r="3" fill="#0B1026" />
      <circle cx="181" cy="119" r="3" fill="#0B1026" />
      <path d="M133 118 Q131 112 135 110" stroke="#0B1026" strokeWidth="1.5" fill="none" opacity="0.5" />
      {/* Waving arms */}
      <motion.path d="M128 130 C114 124, 112 108, 122 102" stroke="#7CF7C2" strokeWidth="6" strokeLinecap="round" animate={{ rotate: [0, 12, 0] }} transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }} style={{ transformOrigin: "128px 130px" }} />
      <motion.path d="M192 130 C206 124, 210 108, 200 102" stroke="#6EE7FF" strokeWidth="6" strokeLinecap="round" animate={{ rotate: [0, -12, 0] }} transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }} style={{ transformOrigin: "192px 130px" }} />
      {/* Lights */}
      <circle cx="110" cy="150" r="4.5" fill="#22D3EE" />
      <circle cx="160" cy="154" r="4.5" fill="#F7C948" />
      <circle cx="210" cy="150" r="4.5" fill="#22D3EE" />
    </motion.svg>
  );
};
